import { render, staticRenderFns } from "./SignatureFiles.vue?vue&type=template&id=645e5b46"
import script from "./SignatureFiles.vue?vue&type=script&lang=js"
export * from "./SignatureFiles.vue?vue&type=script&lang=js"
import style0 from "./SignatureFiles.vue?vue&type=style&index=0&id=645e5b46&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports